<template>
<div class="row">
<div class="col-lg-9">
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Meus pacientes - Unimed Nacional Plus </strong>
      </div>
    </div>
    <div class="card-body">
      <a-table
        :columns="columns"
        :dataSource="data"
        class="utils__scrollTable"
        :scroll="{ x: '100%' }"
      >
        <div
          slot="filterDropdown"
          slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          class="custom-filter-dropdown"
        >
          <a-input
            v-ant-ref="c => searchInput = c"
            :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm)"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-button
            type="primary"
            @click="() => handleSearch(selectedKeys, confirm)"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
          >Search</a-button>
          <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">Reset</a-button>
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered"
          type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
        <template slot="customRender" slot-scope="text">
          <span v-if="searchText">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
            >
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </template>
        <a
          slot="id"
          slot-scope="text"
          href="javascript: void(0);"
          class="utils__link--underlined"
        >#{{text}}</a>
        <span slot="total" slot-scope="text">${{text}}</span>
        <span slot="tax" slot-scope="text">{{text}}</span>
        <span slot="shipping" slot-scope="text">${{text}}</span>
        <span
          slot="status"
          slot-scope="text"
          :class="[text === 'Risco 4' ? 'font-size-12 badge badge-r4' : 'font-size-12 badge badge-r1']"
        >{{text}}</span>
        <span slot="action">
          <a-button icon="edit" class="mr-1" size="small">View</a-button>
          <a-button icon="cross" size="small">Remove</a-button>
        </span>
      </a-table>
    </div>
  </div>
</div>
  <div class="col-lg-3">
     <div class="card">
          <div class="card-header">
            <div class="utils__title">
              <strong>Ações Recomendadas</strong>
            </div>
<!--            <div class="utils__titleDescription">Block with important Task Table information</div>-->
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <a-table
                  :columns="taskTableColumns"
                  :dataSource="taskTableData"
                  :pagination="false"
                  :rowSelection="rowSelection"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="name" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <a slot="username" slot-scope="username" href="javascript: void(0);">{{username}}</a>
<!--                  <a-dropdown slot="actions">-->
<!--                    <a-button size="small">Actions-->
<!--                      <a-icon type="down"/>-->
<!--                    </a-button>-->
<!--                    <a-menu slot="overlay">-->
<!--                      <a-menu-item>-->
<!--                        <a href="javascript:;">1st menu item</a>-->
<!--                      </a-menu-item>-->
<!--                      <a-menu-item>-->
<!--                        <a href="javascript:;">2nd menu item</a>-->
<!--                      </a-menu-item>-->
<!--                      <a-menu-item>-->
<!--                        <a href="javascript:;">3rd menu item</a>-->
<!--                      </a-menu-item>-->
<!--                    </a-menu>-->
<!--                  </a-dropdown>-->
                </a-table>
              </div>
            </div>
          </div>
        </div>
            <div class="card">
          <div class="card-body">
             <div :class="$style.calendarExample">
             <vue-cal :time="false"
             show-week-numbers
             :hide-weekdays="[2, 3, 5]"
             :disable-views="['month','years', 'year']">
                </vue-cal>
             </div>
          </div>
        </div>

  </div>
</div>
</template>

<script>
import {
  data,
  taskTableData,
} from './data.json'

import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows)
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows)
  },
}

const taskTableColumns = [
  {
    title: 'Todas ações',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
]

export default {
  components: { 'vue-cal': VueCal },
  data: function () {
    return {
      taskTableColumns,
      taskTableData,
      VueCal,
      rowSelection,
      data,
      searchText: '',
      searchInput: null,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          sorter: (a, b) => a.id - b.id,
          scopedSlots: { customRender: 'id' },
        },
        {
          title: 'Admissão',
          dataIndex: 'date',
          key: 'date',
        },
        {
          title: 'Nome',
          dataIndex: 'customer',
          key: 'customer',
          sorter: (a, b) => a.name.length - b.name.length,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customer',
          },
          onFilter: (value, record) => record.customer.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              }, 0)
            }
          },
        },
        {
          title: 'Idade',
          dataIndex: 'quantity',
          key: 'quantity',
          scopedSlots: { customRender: 'quantity' },
          sorter: (a, b) => a.total - b.total,
        },
        {
          title: 'Gênero',
          dataIndex: 'tax',
          key: 'tax',
          sorter: (a, b) => a.tax - b.tax,
          scopedSlots: { customRender: 'tax' },
        },
        {
          title: 'Estágio',
          dataIndex: 'estagio',
          key: 'estagio',
          sorter: (a, b) => a.tax - b.tax,
          scopedSlots: { customRender: 'estagio' },

        },
        {
          title: 'Fragilidade',
          dataIndex: 'estagio',
          key: 'estagio',
          scopedSlots: { customRender: 'estagio' },
          sorter: (a, b) => a.shipping - b.shipping,
        },
        {
          title: 'Localização',
          dataIndex: 'estagio',
          key: 'estagio',
          scopedSlots: { customRender: 'estagio' },
          sorter: (a, b) => a.shipping - b.shipping,
        },
        {
          title: 'Índ. Risco',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'Índ. Saúde',
          dataIndex: 'quantity',
          key: 'quantity2',
          scopedSlots: { customRender: 'quantity' },
        },
        {
          title: '',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },

    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
